/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	
	/**
	 * Created by tford on 6/23/16
	 */
	
	/*
	 * Non-friend Message Modal
	 * Used when a user tries to send a message to a user that is not a friend
	 */ 
	
	define('fitbit-jquery-nonfriendMessageModal',['require','jquery'],function(require) {
	    var $ = require("jquery");
	
	    // Prevent duplicate initialization
	    if ($.isFunction($.fn.nonfriendMessageModal)) {
	        return;
	    }
	
	    /*
	     * jQuery Plugin
	     */
	    $.fn.nonfriendMessageModal = function() {
	        var $self = $(this);
	
	        $self.overlay({
	            top: '30%',
	            mask: {
	                maskId: 'nonfriend-message-mask',
	                color: '#000'
	            },
	            close: ".cancel"
	        });
	        $self.data("overlay").load();
	    };
	});
	}.call(window));

/***/ }
/******/ ])


/** WEBPACK FOOTER **
 ** nonfriendMessageModal.js.aa4c4a954e08b58f50d611e55d412378.js
 **/